import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { AdminPanelAccessResponse } from '../interfaces/admin-panel-access.interface';
import { LocalStorageUtil } from '../utils/local-storage.util';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AdminPanelAccessService extends BaseApiService {
  private accessRequest$?: Observable<AdminPanelAccessResponse>;
  private cachedToken = '';
  private cachedLoginUsuario = '';

  getAccess(): Observable<AdminPanelAccessResponse> {
    const token = LocalStorageUtil.getAccessTokenOrDefault('');
    const loginUsuario = LocalStorageUtil.getLoginUsernameOrDefault('').trim();

    if (token !== this.cachedToken || loginUsuario !== this.cachedLoginUsuario) {
      this.accessRequest$ = undefined;
      this.cachedToken = token;
      this.cachedLoginUsuario = loginUsuario;
    }

    if (!this.accessRequest$) {
      const params = loginUsuario
        ? new HttpParams().set('loginUsuario', loginUsuario)
        : new HttpParams();

      this.accessRequest$ = this.getHttpClient()
        .get<AdminPanelAccessResponse>(`${this.getBaseUrl()}/security/admin-panel-access`, {
          headers: this.getAuthHeaders(),
          params
        })
        .pipe(shareReplay(1));
    }

    return this.accessRequest$;
  }

  clearCache(): void {
    this.accessRequest$ = undefined;
    this.cachedToken = '';
    this.cachedLoginUsuario = '';
  }
}
